var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta-middle"},[_c('link-button',{staticClass:"btn1",attrs:{"link":_vm.link},on:{"click":function($event){_vm.$emit('link')}}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("メールアドレス、パスワード1分で簡単登録")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e5ec2b9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Toppage/section/CtaMiddle.vue
// module id = null
// module chunks = 